<div class="help-dialog-container">
  <!-- Cabecera -->
  <div mat-dialog-title class="dialog-header d-flex justify-content-between align-items-center">
    <span>¿Cómo funciona la importación?</span>
    <button mat-icon-button (click)="onClose()" class="close-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    <!-- ¿Qué hace el proceso? -->
    <div class="help-section">
      <div class="section-header">
        <mat-icon class="section-icon text-primary">settings_suggest</mat-icon>
        <h6 class="section-title">El proceso de importación</h6>
      </div>
      <p class="section-text">
        El sistema procesa el documento del padrón y crea automáticamente los <strong>Centros Médicos</strong> basándose en los profesionales y sus direcciones físicas.
      </p>
    </div>

    <!-- Lógica de creación de centros -->
    <div class="help-section">
      <div class="section-header">
        <mat-icon class="section-icon text-info">business</mat-icon>
        <h6 class="section-title">Lógica de creación de centros</h6>
      </div>
      
      <div class="help-card bg-light border-left-info">
        <div class="d-flex align-items-start">
          <mat-icon class="mr-3 text-info">person_pin</mat-icon>
          <div>
            <span class="card-title d-block mb-1">Médicos en múltiples direcciones</span>
            <span class="card-text">Se crean centros distintos por cada dirección. Se nombran usando la <strong>calle y altura</strong>.</span>
          </div>
        </div>
      </div>

      <div class="help-card bg-light border-left-success">
        <div class="d-flex align-items-start">
          <mat-icon class="mr-3 text-success">person</mat-icon>
            <div>
              <span class="card-title d-block mb-1">Médico único en una dirección</span>
              <span class="card-text">El centro médico se nombra automáticamente con el <strong>nombre del profesional</strong>.</span>
            </div>
        </div>
      </div>

      <div class="help-card bg-light border-left-danger">
        <div class="d-flex align-items-start">
          <mat-icon class="mr-3 text-danger">explore</mat-icon>
          <div>
            <span class="card-title d-block mb-1">Geolocalización Automática</span>
            <span class="card-text">Se intenta ubicar cada dirección en el mapa. Si no se encuentra, <strong>el proceso continúa igualmente</strong> para permitir ajustes manuales.</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Teléfonos -->
    <div class="help-section">
      <div class="section-header">
        <mat-icon class="section-icon text-warning">phone</mat-icon>
        <h6 class="section-title">Procesamiento de Teléfonos</h6>
      </div>
      <p class="section-text m-0">
        Los teléfonos detectados se asocian al centro médico mediante una <strong>normalización inteligente</strong>:
      </p>
      <ul class="help-bullets">
        <li>Limpieza de formatos y caracteres inválidos.</li>
        <li>Unificación mediante expresiones regulares.</li>
        <li>Estandarización para evitar duplicados.</li>
      </ul>
    </div>

    <!-- Importante -->
    <div class="footer-alert d-flex align-items-start mt-4">
      <mat-icon class="mr-2">info</mat-icon>
      <div class="section-text m-0">
        <strong>Aviso:</strong> El proceso automatiza la información, pero algunos casos pueden requerir ajustes manuales posteriores.
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="pt-3">
    <button mat-flat-button color="primary" (click)="onClose()" class="px-4">ENTENDIDO</button>
  </mat-dialog-actions>
</div>
